<template>
  <el-dialog :title="$t('payFeeOrderResult.title')" :visible.sync="dialogVisible" width="40%" @close="handleClose"
    :close-on-click-modal="false">
    <div class="result-content">
      <p>{{ paymentSuccessText }}</p>
      <p v-if="!receiptId">{{ $t('payFeeOrderResult.receiptTip') }}</p>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="back">{{ $t('payFeeOrderResult.back') }}</el-button>
      <el-button v-if="receiptId" type="success" @click="printSmall">
        {{ $t('payFeeOrderResult.printSmall') }}
      </el-button>
      <el-button v-if="receiptId" type="primary" @click="printReceipt">
        {{ $t('payFeeOrderResult.printReceipt') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listFeePrintPages, queryFeeReceipt } from '@/api/fee/payFeeOrderApi'

export default {
  name: 'PayFeeOrderResult',
  data() {
    return {
      dialogVisible: false,
      receiptId: '',
      printUrl: '/#/pages/property/printPayFee',
      paymentMethod: '', // 支付方式
      amount: '' // 支付金额
    }
  },
  computed: {
    paymentSuccessText() {
      if (!this.paymentMethod || !this.amount) {
        return this.$t('payFeeOrderResult.success')
      }
      const methodText = this.paymentMethod === '3' ? '微信' : 
                        this.paymentMethod === '4' ? '支付宝' : ''
      if (methodText) {
        return `${methodText}${this.amount}元支付成功`
      }
      return this.$t('payFeeOrderResult.success')
    }
  },
  created() {
    this.listFeePrintPages()
  },
  methods: {
    open(params) {
      if (!params) {
        this.dialogVisible = true
        return
      }
      // 保存支付方式和金额
      this.paymentMethod = params.primeRate || ''
      this.amount = params.amount || params.receivedAmount || ''
      
      // 播放支付成功提示音
      this.playSuccessSound()
      
      this.queryPayFeeReceiptId(params)
    },
    close() {
      this.dialogVisible = false
    },
    async queryPayFeeReceiptId(params) {
      try {
        console.log('查询收据ID参数:', params)
        
        if (!params || !params.detailId) {
          console.warn('未提供detailId，直接显示成功页面')
          this.dialogVisible = true
          return
        }
        
        const communityId = await getCommunityId()
        const response = await queryFeeReceipt({
          detailIds: params.detailId,
          communityId,
          page: 1,
          row: 1
        })

        console.log('查询收据ID返回:', response)

        if (response.code === 0 && response.data && response.data.length > 0) {
          this.receiptId = response.data[0].receiptId
        }
        this.dialogVisible = true
      } catch (error) {
        console.error('查询收据ID失败:', error)
        // 即使查询失败也显示成功页面
        this.dialogVisible = true
      }
    },
    async listFeePrintPages() {
      try {
        const communityId = getCommunityId()
        const response = await listFeePrintPages({
          page: 1,
          row: 1,
          state: 'T',
          communityId
        })

        if (response.data && response.data.length > 0) {
          this.printUrl = response.data[0].url
        }
      } catch (error) {
        console.error('获取打印页面失败:', error)
      }
    },
    printReceipt() {
      window.open(`${this.printUrl}?receiptId=${this.receiptId}`)
    },
    printSmall() {
      window.open(`/#/pages/property/printSmallPayFee?receiptIds=${this.receiptId}`)
    },
    back() {
      this.close()
      this.$router.go(-1)
    },
    handleClose() {
      this.receiptId = ''
      // 触发父组件事件，通知关闭
      this.$emit('close')
    },
    playSuccessSound() {
      try {
        // 使用 Web Audio API 生成提示音
        const AudioContext = window.AudioContext || window.webkitAudioContext
        if (!AudioContext) {
          console.warn('浏览器不支持 Web Audio API')
          return
        }
        
        const audioContext = new AudioContext()
        const oscillator = audioContext.createOscillator()
        const gainNode = audioContext.createGain()
        
        // 设置音调（清脆的“叮”声）
        oscillator.type = 'sine'
        oscillator.frequency.setValueAtTime(800, audioContext.currentTime)
        oscillator.frequency.exponentialRampToValueAtTime(1200, audioContext.currentTime + 0.1)
        
        // 设置音量渐变
        gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3)
        
        // 连接节点
        oscillator.connect(gainNode)
        gainNode.connect(audioContext.destination)
        
        // 播放声音
        oscillator.start(audioContext.currentTime)
        oscillator.stop(audioContext.currentTime + 0.3)
      } catch (error) {
        console.warn('音频播放错误:', error)
      }
    }
  }
}
</script>

<style scoped>
.result-content {
  text-align: center;
  padding: 20px;
}

.dialog-footer {
  text-align: center;
}
</style>